// Shared per-recipient color palette so placed fields (Add Fields editor) and
// recipient summary rows use the same unique color per recipient (by order index).
export const RECIPIENT_COLORS = ["#7A6FF0", "#12B76A", "#F79009", "#E5484D", "#0BA5EC"];

export const recipientColor = (i) => {
  const n = RECIPIENT_COLORS.length;
  return RECIPIENT_COLORS[(((i || 0) % n) + n) % n];
};
